module.exports = __webpack_public_path__ + "static/wwf-mag-abf92f13075f5afdb581a78ae77645cb.jpg";